// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"ae8ee976","580":"c8ac664c","959":"e878a67b"}[chunkId] + ".chunk.css";
};